import { useState, useEffect, useCallback } from "react";
const BASE = "https://imalishawelfare.com/api";
const tok = () => sessionStorage.getItem("token");
const fmt = n => "KSh " + Number(n||0).toLocaleString("en-KE");

const api = async (url, opts={}) => {
  const r = await fetch(BASE + url, { headers:{ Authorization:"Bearer "+tok(), "Content-Type":"application/json" }, ...opts });
  const data = await r.json().catch(()=>({}));
  if (!r.ok) throw new Error(data.message || data.errorMessage || "Request failed");
  return data;
};

const Badge = ({ s }) => {
  const m = { SUCCESS:["#10b981","#f0fdf4"], COMPLETED:["#10b981","#f0fdf4"], FAILED:["#ef4444","#fee2e2"], PENDING:["#f59e0b","#fff8e6"], QUEUED:["#0066cc","#eff6ff"] };
  const [c,bg] = m[s?.toUpperCase()]||["#94a3b8","#f8fafc"];
  return <span style={{ background:bg, color:c, borderRadius:4, padding:"3px 9px", fontSize:11, fontWeight:700 }}>{s}</span>;
};

export default function B2CPayout() {
  const [tab, setTab] = useState("send");
  const [payouts, setPayouts] = useState([]);
  const [pendingApps, setPendingApps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [toast, setToast] = useState({ msg:"", type:"" });
  const [search, setSearch] = useState("");
  const [form, setForm] = useState({
    phone: "", amount: "", remarks: "Loan Disbursement",
    commandId: "BusinessPayment", appId: ""
  });

  const showToast = (msg, type="success") => {
    setToast({ msg, type });
    setTimeout(() => setToast({ msg:"", type:"" }), 5000);
  };

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api("/applications");
      const sorted = data.sort((a,b)=>(b.id||0)-(a.id||0));
      setPayouts(sorted.filter(a => a.loanStatus === "DISBURSED" || a.status === "DISBURSED"));
      setPendingApps(sorted.filter(a => a.loanStatus === "FEE_PAID"));
    } catch(e) {}
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const sendPayout = async () => {
    if (!form.phone || form.phone.length < 10) { showToast("Enter valid 10-digit phone", "error"); return; }
    if (!form.amount || Number(form.amount) < 10) { showToast("Minimum payout is KSh 10", "error"); return; }
    if (!window.confirm(`Send ${fmt(form.amount)} to ${form.phone} via M-Pesa B2C?\n\nThis will send REAL money from the business account.`)) return;
    setSending(true);
    try {
      const phone = form.phone.startsWith("0") ? "254" + form.phone.substring(1) : form.phone;
      const result = await api("/mpesa/b2c", {
        method: "POST",
        body: JSON.stringify({
          phone, amount: Number(form.amount),
          remarks: form.remarks,
          commandId: form.commandId,
          applicationId: form.appId || null
        })
      });
      showToast(`Payout of ${fmt(form.amount)} sent to ${form.phone}!`);
      setForm(f => ({ ...f, phone:"", amount:"", remarks:"Loan Disbursement", appId:"" }));
      load();
    } catch(e) { showToast("Payout failed: " + e.message, "error"); }
    setSending(false);
  };

  const quickPayout = (app) => {
    const net = (app.selectedLoanAmount||0) - (app.loanFeeAmount||0);
    setForm({
      phone: app.phone || "",
      amount: String(net > 0 ? net : app.selectedLoanAmount||0),
      remarks: `Loan for ${app.fullName} APP-${app.id}`,
      commandId: "BusinessPayment",
      appId: String(app.id)
    });
    setTab("send");
    showToast(`Loaded APP-${app.id} — ${app.fullName}. Click Send to disburse.`);
  };

  const filtered = payouts.filter(a => {
    const q = search.toLowerCase();
    return !q || a.fullName?.toLowerCase().includes(q) || a.phone?.includes(q) || a.mpesaReceiptNumber?.includes(q);
  });

  const totalDisbursed = payouts.reduce((s,a)=>s+(a.selectedLoanAmount||0),0);
  const totalNet = payouts.reduce((s,a)=>s+((a.selectedLoanAmount||0)-(a.loanFeeAmount||0)),0);

  return (
    <div style={{ fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif" }}>

      {/* Toast */}
      {toast.msg && (
        <div style={{ position:"fixed", top:20, right:20, zIndex:9999, background:toast.type==="error"?"#ef4444":"#10b981", color:"white", padding:"13px 20px", borderRadius:10, fontSize:13, fontWeight:600, boxShadow:"0 4px 16px rgba(0,0,0,0.2)", maxWidth:380, display:"flex", alignItems:"center", gap:10 }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
            {toast.type==="error" ? <><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></> : <polyline points="20 6 9 17 4 12"/>}
          </svg>
          {toast.msg}
        </div>
      )}

      {/* Header */}
      <div style={{ background:"linear-gradient(135deg,#059669,#047857)", borderRadius:12, padding:"24px 28px", marginBottom:24 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:12, marginBottom:20 }}>
          <div style={{ display:"flex", alignItems:"center", gap:14 }}>
            <div style={{ width:48, height:48, background:"rgba(255,255,255,0.15)", borderRadius:12, display:"flex", alignItems:"center", justifyContent:"center", border:"1.5px solid rgba(255,255,255,0.3)" }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
            </div>
            <div>
              <h2 style={{ color:"white", fontSize:20, fontWeight:800, margin:"0 0 2px" }}>B2C Payout</h2>
              <p style={{ color:"rgba(255,255,255,0.7)", fontSize:12, margin:0 }}>Business to Customer · M-Pesa Shortcode 4010685</p>
            </div>
          </div>
          <button onClick={load} disabled={loading}
            style={{ padding:"9px 18px", background:"rgba(255,255,255,0.15)", color:"white", border:"1.5px solid rgba(255,255,255,0.3)", borderRadius:8, fontWeight:600, fontSize:13, cursor:"pointer", display:"flex", alignItems:"center", gap:8 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></svg>
            Refresh
          </button>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))", gap:12 }}>
          {[
            ["Total Payouts", payouts.length, "Completed"],
            ["Amount Sent", fmt(totalNet), "Net disbursed"],
            ["Pending", pendingApps.length, "Awaiting payout"],
            ["Gross Loans", fmt(totalDisbursed), "Before fees"],
          ].map(([label,value,sub])=>(
            <div key={label} style={{ background:"rgba(255,255,255,0.12)", borderRadius:10, padding:"14px 16px", border:"1px solid rgba(255,255,255,0.15)" }}>
              <p style={{ color:"rgba(255,255,255,0.65)", fontSize:11, fontWeight:600, margin:"0 0 5px", textTransform:"uppercase", letterSpacing:.5 }}>{label}</p>
              <p style={{ color:"white", fontSize:18, fontWeight:800, margin:"0 0 2px" }}>{value}</p>
              <p style={{ color:"rgba(255,255,255,0.5)", fontSize:11, margin:0 }}>{sub}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Tabs */}
      <div style={{ background:"white", borderRadius:10, padding:5, display:"inline-flex", gap:3, marginBottom:20, boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
        {[["send","Send Payout"],["pending",`Pending (${pendingApps.length})`],["history","Payout History"]].map(([id,lbl])=>(
          <button key={id} onClick={()=>setTab(id)}
            style={{ padding:"9px 18px", border:"none", background:tab===id?"#059669":"transparent", color:tab===id?"white":"#64748b", borderRadius:7, fontWeight:tab===id?700:500, fontSize:13, cursor:"pointer", whiteSpace:"nowrap" }}>
            {lbl}
          </button>
        ))}
      </div>

      {/* SEND TAB */}
      {tab==="send" && (
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:20 }}>

          {/* Form */}
          <div style={{ background:"white", borderRadius:12, padding:28, boxShadow:"0 1px 6px rgba(0,0,0,0.06)" }}>
            <h3 style={{ fontSize:15, fontWeight:700, color:"#1e293b", margin:"0 0 20px" }}>Send Money to Customer</h3>

            <div style={{ marginBottom:14 }}>
              <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#64748b", marginBottom:5, textTransform:"uppercase", letterSpacing:.5 }}>Recipient Phone *</label>
              <div style={{ position:"relative" }}>
                <span style={{ position:"absolute", left:12, top:"50%", transform:"translateY(-50%)", fontSize:12, fontWeight:700, color:"#94a3b8" }}>+254</span>
                <input value={form.phone} onChange={e=>setForm(f=>({...f,phone:e.target.value.replace(/\D/g,"")}))} maxLength={10} placeholder="0712345678"
                  style={{ width:"100%", padding:"12px 12px 12px 50px", border:"1.5px solid #e2e8f0", borderRadius:8, fontSize:15, fontWeight:600, boxSizing:"border-box", fontFamily:"monospace" }}/>
              </div>
            </div>

            <div style={{ marginBottom:14 }}>
              <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#64748b", marginBottom:5, textTransform:"uppercase", letterSpacing:.5 }}>Amount (KSh) *</label>
              <div style={{ position:"relative" }}>
                <span style={{ position:"absolute", left:12, top:"50%", transform:"translateY(-50%)", fontSize:12, fontWeight:700, color:"#94a3b8" }}>KSh</span>
                <input type="number" value={form.amount} onChange={e=>setForm(f=>({...f,amount:e.target.value}))} placeholder="Minimum KSh 10" min={10}
                  style={{ width:"100%", padding:"12px 12px 12px 50px", border:"1.5px solid #e2e8f0", borderRadius:8, fontSize:15, fontWeight:700, boxSizing:"border-box" }}/>
              </div>
              {form.amount && <p style={{ fontSize:12, color:"#059669", margin:"4px 0 0", fontWeight:700 }}>{fmt(form.amount)}</p>}
            </div>

            <div style={{ marginBottom:14 }}>
              <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#64748b", marginBottom:5, textTransform:"uppercase", letterSpacing:.5 }}>Command Type</label>
              <select value={form.commandId} onChange={e=>setForm(f=>({...f,commandId:e.target.value}))}
                style={{ width:"100%", padding:"12px", border:"1.5px solid #e2e8f0", borderRadius:8, fontSize:14, boxSizing:"border-box" }}>
                <option value="BusinessPayment">Business Payment (Loan Disbursement)</option>
                <option value="SalaryPayment">Salary Payment</option>
                <option value="PromotionPayment">Promotion Payment</option>
              </select>
            </div>

            <div style={{ marginBottom:14 }}>
              <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#64748b", marginBottom:5, textTransform:"uppercase", letterSpacing:.5 }}>Remarks</label>
              <input value={form.remarks} onChange={e=>setForm(f=>({...f,remarks:e.target.value}))} placeholder="e.g. Loan disbursement APP-001"
                style={{ width:"100%", padding:"12px", border:"1.5px solid #e2e8f0", borderRadius:8, fontSize:14, boxSizing:"border-box" }}/>
            </div>

            <div style={{ background:"#f0fdf4", border:"1px solid #86efac", borderRadius:8, padding:"12px 14px", marginBottom:20 }}>
              <p style={{ color:"#166534", fontSize:12, margin:0, fontWeight:600 }}>
                Money will be sent directly from M-Pesa Business Account 4010685 to the recipient's M-Pesa wallet. No PIN required from recipient.
              </p>
            </div>

            <button onClick={sendPayout} disabled={sending}
              style={{ width:"100%", padding:14, background:sending?"#94a3b8":"linear-gradient(135deg,#059669,#047857)", color:"white", border:"none", borderRadius:9, fontWeight:700, fontSize:15, cursor:sending?"not-allowed":"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:10 }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
              {sending ? "Sending Payout..." : `Send ${form.amount ? fmt(form.amount) : "Payout"}`}
            </button>
          </div>

          {/* Summary + warning */}
          <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
            <div style={{ background:"white", borderRadius:12, padding:24, boxShadow:"0 1px 6px rgba(0,0,0,0.06)" }}>
              <h3 style={{ fontSize:14, fontWeight:700, color:"#1e293b", margin:"0 0 14px" }}>Payout Summary</h3>
              {[["Recipient",form.phone||"—"],["Amount",form.amount?fmt(form.amount):"—"],["Type",form.commandId.replace(/([A-Z])/g," $1").trim()],["Remarks",form.remarks||"—"],["Direction","Business → Customer"],["Method","M-Pesa B2C API"],["Shortcode","4010685"]].map(([k,v])=>(
                <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"8px 0", borderBottom:"1px solid #f1f5f9", fontSize:13 }}>
                  <span style={{ color:"#64748b" }}>{k}</span>
                  <span style={{ fontWeight:600, color:"#1e293b", textAlign:"right", maxWidth:200, wordBreak:"break-all" }}>{v}</span>
                </div>
              ))}
            </div>

            <div style={{ background:"#fff8e6", border:"1.5px solid #f59e0b", borderRadius:10, padding:"16px 18px" }}>
              <p style={{ color:"#92400e", fontSize:13, fontWeight:700, margin:"0 0 8px", display:"flex", alignItems:"center", gap:8 }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                Important Warning
              </p>
              <p style={{ color:"#92400e", fontSize:12, margin:0, lineHeight:1.8 }}>
                B2C sends <strong>real money</strong> immediately from your M-Pesa business account. This action cannot be reversed. Double-check the phone number and amount before sending.
              </p>
            </div>

            <div style={{ background:"white", borderRadius:10, padding:"16px 18px", boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
              <p style={{ fontSize:13, fontWeight:700, color:"#1e293b", margin:"0 0 10px" }}>Quick Load from Pending</p>
              {pendingApps.length===0 ? <p style={{ color:"#94a3b8", fontSize:13 }}>No pending disbursements</p> :
                pendingApps.slice(0,5).map(a=>(
                  <div key={a.id} onClick={()=>quickPayout(a)}
                    style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"9px 0", borderBottom:"1px solid #f1f5f9", cursor:"pointer" }}
                    onMouseEnter={e=>e.currentTarget.style.background="#f0fdf4"}
                    onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                    <div>
                      <p style={{ fontSize:13, fontWeight:600, color:"#1e293b", margin:0 }}>{a.fullName}</p>
                      <p style={{ fontSize:11, color:"#94a3b8", margin:0 }}>{a.phone} · APP-{a.id}</p>
                    </div>
                    <span style={{ fontSize:13, fontWeight:700, color:"#059669" }}>{fmt((a.selectedLoanAmount||0)-(a.loanFeeAmount||0))}</span>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      )}

      {/* PENDING TAB */}
      {tab==="pending" && (
        <div style={{ background:"white", borderRadius:12, boxShadow:"0 1px 6px rgba(0,0,0,0.06)", overflow:"hidden" }}>
          <div style={{ padding:"14px 20px", borderBottom:"1px solid #f1f5f9", background:"#fffbeb", display:"flex", alignItems:"center", gap:10 }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            <p style={{ color:"#92400e", fontSize:13, fontWeight:600, margin:0 }}>
              {pendingApps.length} applicant{pendingApps.length!==1?"s":""} paid fee and waiting for loan payout
            </p>
          </div>
          {pendingApps.length===0 ? (
            <div style={{ padding:48, textAlign:"center" }}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#e2e8f0" strokeWidth="1.5" style={{ margin:"0 auto 12px", display:"block" }}><polyline points="20 6 9 17 4 12"/></svg>
              <p style={{ color:"#94a3b8", fontSize:14 }}>No pending payouts</p>
            </div>
          ) : (
            <div style={{ overflowX:"auto" }}>
              <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
                <thead><tr style={{ background:"#f8fafc" }}>
                  {["APP","Applicant","Phone","County","Loan","Fee Paid","Net Payout","M-Pesa Receipt","Action"].map(h=>(
                    <th key={h} style={{ padding:"10px 14px", textAlign:"left", fontWeight:600, color:"#64748b", fontSize:11, textTransform:"uppercase", whiteSpace:"nowrap" }}>{h}</th>
                  ))}
                </tr></thead>
                <tbody>
                  {pendingApps.map((a,i)=>{
                    const net=(a.selectedLoanAmount||0)-(a.loanFeeAmount||0);
                    return (
                      <tr key={a.id} style={{ borderTop:"1px solid #f1f5f9", background:i%2?"#fafafa":"white" }}>
                        <td style={{ padding:"12px 14px", color:"#0066cc", fontWeight:700 }}>APP-{a.id}</td>
                        <td style={{ padding:"12px 14px" }}>
                          <div style={{ fontWeight:600, color:"#1e293b" }}>{a.fullName}</div>
                          <div style={{ fontSize:11, color:"#94a3b8" }}>{a.email}</div>
                        </td>
                        <td style={{ padding:"12px 14px", fontFamily:"monospace", color:"#334155" }}>{a.phone||"—"}</td>
                        <td style={{ padding:"12px 14px", color:"#64748b" }}>{a.county||"—"}</td>
                        <td style={{ padding:"12px 14px", fontWeight:700, color:"#0052a3" }}>{fmt(a.selectedLoanAmount)}</td>
                        <td style={{ padding:"12px 14px", color:"#10b981", fontWeight:600 }}>{fmt(a.loanFeeAmount)}</td>
                        <td style={{ padding:"12px 14px", fontWeight:800, color:"#059669", fontSize:15 }}>{fmt(net)}</td>
                        <td style={{ padding:"12px 14px", fontFamily:"monospace", fontSize:12, color:"#7c3aed" }}>{a.mpesaReceiptNumber||"—"}</td>
                        <td style={{ padding:"12px 14px", display:"flex", gap:6 }}>
                          <button onClick={()=>quickPayout(a)} style={{ padding:"6px 12px", background:"#eff6ff", color:"#0066cc", border:"none", borderRadius:6, fontSize:11, fontWeight:600, cursor:"pointer" }}>
                            Load
                          </button>
                          <button onClick={async()=>{
                            if(!window.confirm(`Send ${fmt(net)} to ${a.fullName} (${a.phone})?`)) return;
                            setSending(true);
                            try {
                              const phone = (a.phone||"").startsWith("0") ? "254" + a.phone.substring(1) : a.phone;
                              await api("/mpesa/b2c", { method:"POST", body:JSON.stringify({ phone, amount:net, remarks:`Loan APP-${a.id}`, commandId:"BusinessPayment", applicationId:a.id }) });
                              showToast(`Sent ${fmt(net)} to ${a.fullName}!`);
                              load();
                            } catch(e) { showToast("Failed: "+e.message,"error"); }
                            setSending(false);
                          }} disabled={sending}
                            style={{ padding:"6px 12px", background:"linear-gradient(135deg,#059669,#047857)", color:"white", border:"none", borderRadius:6, fontSize:11, fontWeight:700, cursor:"pointer", whiteSpace:"nowrap" }}>
                            Send {fmt(net)}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* HISTORY TAB */}
      {tab==="history" && (
        <div style={{ background:"white", borderRadius:12, boxShadow:"0 1px 6px rgba(0,0,0,0.06)", overflow:"hidden" }}>
          <div style={{ padding:"14px 20px", borderBottom:"1px solid #f1f5f9", display:"flex", alignItems:"center", gap:12, flexWrap:"wrap" }}>
            <div style={{ position:"relative", flex:1, minWidth:200 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" style={{ position:"absolute", left:10, top:"50%", transform:"translateY(-50%)" }}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search name, phone, receipt..."
                style={{ width:"100%", padding:"8px 10px 8px 32px", border:"1px solid #e2e8f0", borderRadius:7, fontSize:13, boxSizing:"border-box" }}/>
            </div>
            <span style={{ color:"#94a3b8", fontSize:12 }}>{filtered.length} payouts</span>
            <span style={{ color:"#059669", fontSize:13, fontWeight:700 }}>Total: {fmt(filtered.reduce((s,a)=>s+((a.selectedLoanAmount||0)-(a.loanFeeAmount||0)),0))}</span>
            <button onClick={load} style={{ padding:"7px 14px", background:"#f1f5f9", color:"#64748b", border:"none", borderRadius:7, fontSize:12, fontWeight:600, cursor:"pointer" }}>Refresh</button>
          </div>
          {loading ? (
            <div style={{ padding:40, textAlign:"center", color:"#94a3b8" }}>Loading payout history...</div>
          ) : (
            <div style={{ overflowX:"auto" }}>
              <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
                <thead><tr style={{ background:"#f8fafc" }}>
                  {["APP","Recipient","Phone","County","Loan Amount","Fee","Net Sent","M-Pesa Receipt","Txn ID","Status"].map(h=>(
                    <th key={h} style={{ padding:"10px 14px", textAlign:"left", fontWeight:600, color:"#64748b", fontSize:11, textTransform:"uppercase", whiteSpace:"nowrap" }}>{h}</th>
                  ))}
                </tr></thead>
                <tbody>
                  {filtered.length===0 ? (
                    <tr><td colSpan={10} style={{ padding:40, textAlign:"center", color:"#94a3b8" }}>No payout history yet</td></tr>
                  ) : filtered.map((a,i)=>(
                    <tr key={a.id} style={{ borderTop:"1px solid #f1f5f9", background:i%2?"#fafafa":"white" }}>
                      <td style={{ padding:"10px 14px", color:"#0066cc", fontWeight:700 }}>APP-{a.id}</td>
                      <td style={{ padding:"10px 14px" }}>
                        <div style={{ fontWeight:600, color:"#1e293b" }}>{a.fullName}</div>
                        <div style={{ fontSize:11, color:"#94a3b8" }}>{a.email}</div>
                      </td>
                      <td style={{ padding:"10px 14px", fontFamily:"monospace", color:"#334155" }}>{a.phone||"—"}</td>
                      <td style={{ padding:"10px 14px", color:"#64748b" }}>{a.county||"—"}</td>
                      <td style={{ padding:"10px 14px", fontWeight:700, color:"#0052a3" }}>{fmt(a.selectedLoanAmount)}</td>
                      <td style={{ padding:"10px 14px", color:"#10b981", fontWeight:600 }}>{fmt(a.loanFeeAmount)}</td>
                      <td style={{ padding:"10px 14px", fontWeight:800, color:"#059669" }}>{fmt((a.selectedLoanAmount||0)-(a.loanFeeAmount||0))}</td>
                      <td style={{ padding:"10px 14px", fontFamily:"monospace", fontSize:12, color:"#7c3aed" }}>{a.mpesaReceiptNumber||"—"}</td>
                      <td style={{ padding:"10px 14px", fontFamily:"monospace", fontSize:11, color:"#94a3b8", maxWidth:120, overflow:"hidden", textOverflow:"ellipsis" }}>{a.mpesaTransactionId||"—"}</td>
                      <td style={{ padding:"10px 14px" }}><Badge s={a.loanStatus||a.status}/></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}


